import merge from 'lodash/merge';

import {
  ConfigurationTypography,
  getDefaultConfigurationTheme,
  ThemeCode,
  TinkLinkThemeConfiguration,
} from '@tink/config/src/tinkLinkConfig';
import {
  theme as defaultTinkTheme,
  TinkTheme,
} from '@tink/core/src/components/providers/ThemeProvider/theme';
import { getThemeParameter } from '../ConfigurationProvider/ConfigurationProvider';

export interface TinkLinkTheme extends TinkTheme {
  configuration: TinkLinkThemeConfiguration;
  typography: ConfigurationTypography;
}

export const tinkLinkTheme: TinkLinkTheme = merge(
  {
    configuration: {
      ...getDefaultConfigurationTheme(getThemeParameter() || ThemeCode.LIGHT).colors,
      buttons: getDefaultConfigurationTheme(getThemeParameter() || ThemeCode.LIGHT).buttons,
      header: getDefaultConfigurationTheme(getThemeParameter() || ThemeCode.LIGHT).header,
      textAlignment: getDefaultConfigurationTheme(getThemeParameter() || ThemeCode.LIGHT)
        .textAlignment,
    },
  },
  defaultTinkTheme,
  {
    font: {
      face: getDefaultConfigurationTheme(getThemeParameter() || ThemeCode.LIGHT).fonts.fontFamily,
    },
    typography: getDefaultConfigurationTheme(getThemeParameter() || ThemeCode.LIGHT).typography,
  }
);
